__turbopack_context__.v({
  "className": "inter_1c641e57-module__F6YE1W__className",
  "variable": "inter_1c641e57-module__F6YE1W__variable",
});
